<template>
  <div class="buttons">
    <div class="buttons">
      <ButtonElement
        v-if="!showForm"
        color="success"
        :icon="PhPlus"
        bordered
        @click="openVin(undefined)"
        >Ajouter un vin</ButtonElement
      >
      <ButtonElement v-else color="bordeaux" bordered :icon="PhArrowLeft" @click="showForm = false">
        Retour
      </ButtonElement>
    </div>
  </div>
  <!-- Formulaire de création/modification -->
  <OrdreFabricationVinForm
    v-if="showForm"
    :produits
    v-model:ordre-fabrication="ordreFabrication"
    v-model:vin="vin"
    v-model:show-form="showForm"
  />
  <template v-else>
    <div class="cards" v-if="ordreFabrication.vins.length">
      <CardComponent
        v-for="vin in ordreFabrication.vins"
        :key="vin.id"
        :icon="PhWine"
        :title="`Vin n°${vin.ordre}`"
      >
        <template #buttons>
          <ButtonElement color="bordeaux" :icon="PhPen" size="small" @click="openVin(vin)"
            >Modifier</ButtonElement
          >
        </template>

        <CardInfoComponent title="Appellation">{{ vin.appellation }}</CardInfoComponent>
      </CardComponent>
    </div>
    <div class="message" v-else>
      <PhWarning />
      <span>Aucun vin n'est enregistré.</span>
    </div>
  </template>
</template>

<script setup lang="ts">
import { PhArrowLeft, PhPen, PhPlus, PhWarning, PhWine } from '@phosphor-icons/vue'
import type { OrdreFabricationGet, OrdreFabricationVin } from '@/interfaces/OrdreFabrication.ts'
import ButtonElement from '@/components/ButtonElement.vue'
import { type PropType, ref, type Ref, toRaw } from 'vue'
import OrdreFabricationVinForm from '@/components/ordre-fabrication/OrdreFabricationVinForm.vue'
import type { ProduitFiltrationList } from '@/interfaces/ProduitFiltrationList.ts'
import CardComponent from '@/components/card/CardComponent.vue'
import CardInfoComponent from '@/components/card/CardInfoComponent.vue'

// modèle
const ordreFabrication = defineModel<OrdreFabricationGet>({ required: true })

// props
defineProps({
  produits: {
    type: Array as PropType<ProduitFiltrationList[]>,
    required: true,
  },
})

// données
const showForm: Ref<boolean> = ref(false)
const vin: Ref<OrdreFabricationVin> = ref({})

// gestion des vins
function openVin(vinItem: OrdreFabricationVin | undefined = undefined) {
  // ouvre le formulaire de modification avec le vin choisi
  if (vinItem) vin.value = structuredClone(toRaw(vinItem))
  else {
    vin.value = {
      ordre: null,
      appellation: '',
      degro: false,
      cubi: false,
      mise: false,
      mise_client: false,
      vin_bio: false,
      vin_sans_souffre: false,
      filtrage_inertage: false,
      couleur: '',
      cuvee: null,
      cuve_depart: null,
      cuve_reception: null,
      filtration_k1: false,
      filtration_k2: false,
      filtration_tg: false,
      gaz_debut: null,
      gaz_fin: null,
      temperature_vin: null,
      observations: '',
      presence_allergenes: false,
      presence_allergenes_precision: '',
      analyse_fournie: false,
      vin_colle: false,
    }
  }
  showForm.value = true
}
</script>
